import { Resource } from '@nextforce/api'
import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { FileFolderSortOption } from 'file_folder_repository/types'
import {
  FileListItem,
  FolderListItem,
} from 'file_folder_repository/views/list_item'
import { View } from 'react-native'
import { FlatList } from 'react-native-gesture-handler'
import Animated, { FadeIn } from 'react-native-reanimated'

export interface FileFolderListProps {
  chatGroupFileFolderList: Resource[] | undefined
  onPress(resource: Resource): void

  onLongPressResource(resource: Resource): void
  sortOption: FileFolderSortOption
}

export const FileFolderListView = ({
  chatGroupFileFolderList,
  onLongPressResource,
  onPress,

  sortOption,
}: FileFolderListProps) => {
  const styles = useStyles()

  return (
    <View style={styles.container}>
      <FlatList
        data={chatGroupFileFolderList}
        keyExtractor={item => item.id + item.name}
        renderItem={({ item, index }) => (
          <Animated.View entering={FadeIn.delay(index * 50)}>
            {item.type === 'file' ? (
              <FileListItem
                key={item.id + item.name}
                file={item}
                onPress={onPress}
                onLongPress={onLongPressResource}
                metaDataType={sortOption}
              />
            ) : (
              <FolderListItem
                key={item.id + item.name}
                folder={item}
                onPress={onPress}
                onLongPress={onLongPressResource}
                metaDataType={sortOption}
              />
            )}
          </Animated.View>
        )}
        ListEmptyComponent={() => (
          <View style={styles.emptyComponent}>
            <Text style={styles.emptyComponentText}>
              {t('noFilesOrFoldersFound')}
            </Text>
          </View>
        )}
        contentContainerStyle={styles.fileFolderListContainer}
      />
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
  },
  searchBarContainer: { marginHorizontal: 10, marginTop: 10 },
  breadcrumbsContainer: { padding: 10 },
  fileFolderListContainer: {
    paddingBottom: 100,
    flexGrow: 1,
    backgroundColor:
      theme.mode === 'dark' ? theme.colors.white : theme.colors.grey6,
  },
  pasteComponentContainer: {
    padding: 10,
    flexDirection: 'row',
    alignItems: 'stretch',
  },
  pasteButtonContainer: {
    borderRadius: 20,
    backgroundColor: theme.colors.primary,
    flex: 1,
    marginRight: 10,
    justifyContent: 'center',
  },
  loadingIndicator: {
    color: theme.colors.primary,
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyComponent: { flex: 1, justifyContent: 'center' },
  emptyComponentText: { textAlign: 'center' },
  cancelButton: {
    borderRadius: 50,
    justifyContent: 'center',
    alignItems: 'center',
    height: 40,
    width: 40,
  },
}))
